export default {
      id: "small-arrow-down-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "sprite.svg#small-arrow-down",
      toString: function () {
        return this.url;
      }
    }